// Google Analytics utility functions
export const trackEvent = (action, category, label = null, value = null) => {
  if (window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

// Predefined tracking functions for common actions
export const analytics = {
  // PDF Unlocker events
  pdfUnlocker: {
    fileSelected: (fileName, fileSize) => 
      trackEvent('file_selected', 'PDF_Unlocker', fileName, fileSize),
    fileSelectionError: (error) => 
      trackEvent('file_selection_error', 'PDF_Unlocker', error),
    unlockAttempt: (fileName) => 
      trackEvent('unlock_attempt', 'PDF_Unlocker', fileName),
    unlockSuccess: (fileName, fileSize) => 
      trackEvent('unlock_success', 'PDF_Unlocker', fileName, fileSize),
    unlockError: (error) => 
      trackEvent('unlock_error', 'PDF_Unlocker', error),
    unlockAttemptError: (error) => 
      trackEvent('unlock_attempt_error', 'PDF_Unlocker', error),
    downloadUnlockedPdf: (fileName) => 
      trackEvent('download_unlocked_pdf', 'PDF_Unlocker', fileName),
    downloadCompressedPdf: (fileName, compressionLevel, fileSize) => 
      trackEvent('download_compressed_pdf', 'PDF_Unlocker', `${fileName}_${compressionLevel}`, fileSize),
    compressionAttempt: (fileName, compressionLevel) => 
      trackEvent('compression_attempt', 'PDF_Unlocker', `${fileName}_${compressionLevel}`),
    compressionError: (error) => 
      trackEvent('compression_error', 'PDF_Unlocker', error)
  },

  // Navigation events
  navigation: {
    headerNavigation: (destination) => 
      trackEvent('header_navigation', 'Navigation', destination)
  },

  // Contact events
  contact: {
    emailClick: (email) => 
      trackEvent('email_click', 'Contact', email)
  },

  // Social media events
  socialMedia: {
    socialMediaClick: (platform) => 
      trackEvent('social_media_click', 'Social_Media', platform)
  }
}; 